import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import dayOfYear from 'dayjs/plugin/dayOfYear'
import utc from 'dayjs/plugin/utc'
import duration from 'dayjs/plugin/duration'

dayjs.extend(localizedFormat)
dayjs.extend(dayOfYear)
dayjs.extend(utc)
dayjs.extend(duration)

export { dayjs as dayJS }

export const getFormattedDate = (date?: string) => {
  return dayjs(date).format('D MMM YYYY, HH:mm')
}

export const getFormattedDateOnly = (date?: string) => {
  return dayjs.utc(date).format('D MMM YYYY')
}
